import ehlo from './ehlo.js'
import clearWebViewCache from './clear-web-view-cache.js'
import contactsSettingsPermissions from './contacts-settings-permissions.js'
import contactsList from './contacts-list.js'
import devTest from './dev-test.js'
import share from './share.js'
import shareDigitalFlyer from './share-digital-flyer.js'
import download from './download.js'
import pushToken from './push-token.js'
import analyticsEvent from './analytics-event.js'
import subscriptionPlans from './subscription-plans.js'
import subscriptionBuyAndroid from './subscription-buy-android.js'
import subscriptionOwnedAndroid from './subscription-owned-android.js'
import subscriptionBuyIos from './subscription-buy-ios.js'
import subscriptionRestoreIos from './subscription-restore-ios.js'
import subscriptionTransactionDoneIos from './subscription-transaction-done-ios.js'
import subscriptionRefreshReceiptIos from './subscription-refresh-receipt-ios.js'
import authLogin from './auth-login.js'
import authLogout from './auth-logout.js'
import supportOpen from './support-open.js'
import oauthApple from './oauth-apple.js'
import oauthFb from './oauth-fb.js'
import close from './close.js'
import locationRequest from './location-request.js'

import onboardingBusinessCreated from './onboarding-business-created.js'
import onboardingBusinessUpdated from './onboarding-business-updated.js'

/*
 * Argument `_this` contains:
 *  `sendEvent`
 *  `sendEventWithCallback`
 *  `ERROR_TIMEOUT`,
 *  `ERROR_UNKNOWN`
 * and becomes `this` in functions!
 */
export function makeCustomEvents (_this) {
  return Object.entries({
    /*
     * put new custom events functions here
     */
    ehlo,
    clearWebViewCache,
    contactsSettingsPermissions,
    contactsList,
    devTest,
    share,
    shareDigitalFlyer,
    download,
    pushToken,
    analyticsEvent,
    subscriptionPlans,
    subscriptionBuyAndroid,
    subscriptionOwnedAndroid,
    subscriptionBuyIos,
    subscriptionRestoreIos,
    subscriptionTransactionDoneIos,
    subscriptionRefreshReceiptIos,
    authLogin,
    authLogout,
    supportOpen,
    oauthApple,
    oauthFb,
    close,
    locationRequest,
    onboardingBusinessCreated,
    onboardingBusinessUpdated,
  }).reduce((events, entry) => {
    const [name, fn] = entry
    events[name] = fn.bind(_this)
    return events
  }, {})
}
